import { Table } from 'rsuite';

import './styles.css';

const { HeaderCell } = Table;

/**
 * Custom Toggle component that applies the primary color of the custom theme to the checked state.
 * @component
 * @param {import('rsuite/esm/Table').HeaderCellProps} rest - Additional props to pass to the Toggle component.
 * @returns {JSX.Element} CustomToggle component.
 */

export function CustomHeaderCell({ children, ...rest }) {
  return (
    <HeaderCell className="custom-header-cell" {...rest}>
      {children}
    </HeaderCell>
  );
}
